var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8998AA",
    fillRule: "evenodd",
    transform: "translate(3 3.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    y: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 2,
    y: 7.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 2,
    y: 4.501,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8998AA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.472.93l1.732 1-5.312 9.201-1.732-1 5.312-9.2zM6.16 10.132l1.732 1-2.554 2.424.822-3.424z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic-edit.426630b4d00953e0ec3a2890730c3c6e.svg";
export { ForwardRef as ReactComponent };